export default __webpack_public_path__ + "static/result_back-9b2e51f40f81e0005274f91102a9ddab.webp";